import Reflux from 'reflux';

const CourseDetail = Reflux.createActions([
  'read',
  'nextStudents',
  'prevStudents',
  'countStudents',
  'filterStudents',
  'filterStudentsByStatus',
]);

export default CourseDetail;



// WEBPACK FOOTER //
// ./src/js/actions/CourseDetail.js